import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { EventBusUtils } from "@/utils";
import { EventConstant } from "@/const";

const AppLoading = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpenLoading = (open: boolean) => {
    setIsOpen(open);
  };

  useEffect(() => {
    EventBusUtils.on<boolean>(EventConstant.GLOBAL_EVENTS.toggleOpenLoading, handleOpenLoading);

    return () => EventBusUtils.off<boolean>(EventConstant.GLOBAL_EVENTS.toggleOpenLoading, handleOpenLoading);
  });

  return (
    <Backdrop open={isOpen} sx={{ color: "#fff", zIndex: theme => theme.zIndex.drawer + 1301 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default AppLoading;
